import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseLeadPage, CarleadStep1CustomerPopup, CarleadTopBlueCarHCSliderMap } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStep1CustomerPopup}
      content={CarleadTopBlueCarHCSliderMap}
      className='mobile-blue-bg'
      howItWorksShowCta={false}
      headlineDesktop='carleadCreation.form.title'
      headlineMobile='carleadCreation.form.title'
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
